export default __webpack_public_path__ + "static/media/telefonica_logo_white.7552063d.svg";